"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.findExtrasSection = exports.sectionIndexForStep = exports.buildWizardSteps = exports.DeclarationCard = exports.WizardNav = exports.RequiredFieldsHint = exports.StepProgressBar = exports.BrandedHeader = exports.stepLabelFor = void 0;
const react_1 = __importDefault(require("react"));
const icons_1 = require("./icons");
/* ─── Canonical step label per section id ────────────────────── */
const STEP_LABEL = {
    basic: 'Personal',
    program: 'Programme',
    course: 'Course',
    family: 'Family',
    address: 'Address',
    education: 'Qualifications',
    workExperience: 'Experience',
    referral: 'Referral',
    documents: 'Documents',
    testRegistration: 'Test',
    payment: 'Payment',
    review: 'Review',
};
function stepLabelFor(section) {
    return STEP_LABEL[section.id] || section.title || section.id;
}
exports.stepLabelFor = stepLabelFor;
const BrandedHeader = ({ institution, tagline = 'Student Application Portal', reference, logo, }) => {
    const initial = (institution || 'A').replace(/^[^A-Za-z0-9]+/, '').charAt(0).toUpperCase() || 'A';
    return (react_1.default.createElement("header", { className: "wf-brand-header" },
        react_1.default.createElement("div", { className: "wf-brand-header-inner" },
            react_1.default.createElement("div", { className: "wf-brand-left" },
                react_1.default.createElement("div", { className: "wf-brand-logo", "aria-hidden": "true" }, logo ? react_1.default.createElement("img", { src: logo, alt: "" }) : react_1.default.createElement("span", null, initial)),
                react_1.default.createElement("div", { className: "wf-brand-titles" },
                    react_1.default.createElement("span", { className: "wf-brand-name" }, institution),
                    react_1.default.createElement("span", { className: "wf-brand-tagline" }, tagline))),
            reference && react_1.default.createElement("span", { className: "wf-brand-ref" },
                "REF: ",
                reference))));
};
exports.BrandedHeader = BrandedHeader;
const StepProgressBar = ({ steps, activeIndex, onJumpToStep, allCompleted, erroredSteps }) => (react_1.default.createElement("nav", { className: "wf-steps-bar", "aria-label": "Application progress" },
    react_1.default.createElement("div", { className: "wf-steps-bar-inner" },
        react_1.default.createElement("ol", { className: `wf-steps-list${onJumpToStep ? ' wf-steps-list-nav' : ''}` }, steps.map((s, i) => {
            const isActive = i === activeIndex;
            const isError = !!erroredSteps?.has(i);
            const isDone = !isError && (allCompleted ? i !== activeIndex : i < activeIndex);
            const clickable = !!onJumpToStep && i !== activeIndex;
            const commonClass = `wf-step${isActive ? ' is-active' : ''}${isDone ? ' is-completed' : ''}${isError ? ' is-error' : ''}${clickable ? ' is-clickable' : ''}`;
            const inner = (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("span", { className: "wf-step-bubble" }, isError ? '!' : (isDone ? react_1.default.createElement(icons_1.IconCheck, { size: 12, strokeWidth: 3 }) : i + 1)),
                react_1.default.createElement("span", { className: "wf-step-label" }, s.label)));
            return (react_1.default.createElement("li", { key: s.id, className: commonClass, "aria-current": isActive ? 'step' : undefined }, clickable ? (react_1.default.createElement("button", { type: "button", className: "wf-step-btn", onClick: () => onJumpToStep?.(i), "aria-label": `Jump to ${s.label}` }, inner)) : (inner)));
        })),
        react_1.default.createElement("div", { className: "wf-step-mobile" },
            "Step ",
            react_1.default.createElement("strong", null,
                activeIndex + 1,
                " of ",
                steps.length),
            " \u2014 ",
            steps[activeIndex]?.label))));
exports.StepProgressBar = StepProgressBar;
/* ─── Required-fields hint bar ───────────────────────────────── */
const RequiredFieldsHint = () => (react_1.default.createElement("div", { className: "wf-hint-bar", role: "note" },
    react_1.default.createElement(icons_1.IconInfo, { size: 15 }),
    react_1.default.createElement("span", null,
        "Fields marked with ",
        react_1.default.createElement("span", { style: { color: '#ef4444', fontWeight: 600 } }, "*"),
        " are required. Your progress is automatically saved.")));
exports.RequiredFieldsHint = RequiredFieldsHint;
const WizardNav = ({ step, onBack, onNext, onSaveDraft, submitting, isFinalizedEdit, onUpdate, }) => (react_1.default.createElement("div", { className: "wf-wizard-nav" },
    step > 0 ? (react_1.default.createElement("button", { type: "button", className: "wf-btn wf-btn-ghost", onClick: onBack, disabled: submitting },
        react_1.default.createElement(icons_1.IconChevronLeft, { size: 14 }),
        " Back")) : react_1.default.createElement("span", null),
    react_1.default.createElement("span", { className: "wf-wizard-nav-spacer" }),
    !isFinalizedEdit && onSaveDraft && (react_1.default.createElement("button", { type: "button", className: "wf-btn wf-btn-ghost", onClick: onSaveDraft, disabled: submitting }, "Save Draft")),
    isFinalizedEdit && onUpdate && (react_1.default.createElement("button", { type: "button", className: "wf-btn wf-btn-primary", onClick: onUpdate, disabled: submitting }, submitting ? 'Updating…' : 'Update Application')),
    react_1.default.createElement("button", { type: "button", className: `wf-btn ${isFinalizedEdit ? 'wf-btn-ghost' : 'wf-btn-primary'}`, onClick: onNext, disabled: submitting },
        "Continue ",
        react_1.default.createElement(icons_1.IconChevronRight, { size: 14 }))));
exports.WizardNav = WizardNav;
const DeclarationCard = ({ remarksField, remarksValue, onRemarksChange, declarationAccepted, onDeclarationChange, onBack, onSaveDraft, submitting, submitError, isFinalizedEdit, }) => (react_1.default.createElement("div", { className: "section-card wf-decl-card" },
    react_1.default.createElement("div", { className: "section-header" },
        react_1.default.createElement("div", { className: "section-icon", style: { background: '#fef9c3', color: '#b45309' } },
            react_1.default.createElement(icons_1.IconShield, { size: 16 })),
        react_1.default.createElement("div", null,
            react_1.default.createElement("div", { className: "section-title" }, isFinalizedEdit ? 'Review & Update' : 'Declaration & Submit'),
            react_1.default.createElement("div", { className: "section-subtitle" }, isFinalizedEdit
                ? 'Review your changes before updating this application.'
                : 'Confirm your details to submit your application.'))),
    react_1.default.createElement("div", { className: "section-body" },
        remarksField && (react_1.default.createElement("div", { className: "field-group field-full" },
            react_1.default.createElement("label", { className: "field-label", htmlFor: remarksField.key }, remarksField.label),
            react_1.default.createElement("textarea", { id: remarksField.key, className: "field-input", name: remarksField.key, rows: 3, value: remarksValue, onChange: (e) => onRemarksChange(e.target.value), placeholder: "Anything else you'd like us to know?" }))),
        !isFinalizedEdit && (react_1.default.createElement("label", { className: "wf-decl-box" },
            react_1.default.createElement("input", { type: "checkbox", checked: declarationAccepted, onChange: (e) => onDeclarationChange(e.target.checked) }),
            react_1.default.createElement("span", { className: "wf-decl-text" }, "I confirm that all the information provided in this application is accurate and complete to the best of my knowledge. I understand that any false information may result in the cancellation of my application."))),
        submitError && (react_1.default.createElement("div", { className: "error-alert", style: { marginTop: 14 } },
            react_1.default.createElement(icons_1.IconShield, { size: 16 }),
            react_1.default.createElement("span", null, submitError))),
        react_1.default.createElement("div", { className: "wf-decl-footer" },
            react_1.default.createElement("button", { type: "button", className: "wf-btn wf-btn-ghost", onClick: onBack, disabled: submitting },
                react_1.default.createElement(icons_1.IconChevronLeft, { size: 14 }),
                " Back"),
            react_1.default.createElement("div", { className: "wf-decl-footer-right" },
                !isFinalizedEdit && onSaveDraft && (react_1.default.createElement("button", { type: "button", className: "wf-btn wf-btn-ghost", onClick: onSaveDraft, disabled: submitting }, "Save Draft")),
                react_1.default.createElement("button", { type: "submit", className: "wf-btn wf-btn-primary", disabled: (!isFinalizedEdit && !declarationAccepted) || submitting }, submitting
                    ? (isFinalizedEdit ? 'Updating…' : 'Submitting…')
                    : (isFinalizedEdit ? 'Update Application' : 'Submit Application →')),
                !isFinalizedEdit && (react_1.default.createElement("span", { className: "wf-trust-line" },
                    react_1.default.createElement(icons_1.IconShield, { size: 12 }),
                    "Secure submission \u00B7 Confirmation sent to your email")))))));
exports.DeclarationCard = DeclarationCard;
/* ─── Helpers ────────────────────────────────────────────────── */
/**
 * Build the wizard step list from a form definition.
 * The "extras" section (if present) is folded into the final "Review" step and
 * therefore does NOT produce a separate wizard step.
 */
function buildWizardSteps(definition) {
    const sectionSteps = definition.sections
        .filter((s) => s.id !== 'extras')
        .map((s) => ({ id: s.id, label: stepLabelFor(s) }));
    return [...sectionSteps, { id: 'review', label: 'Review' }];
}
exports.buildWizardSteps = buildWizardSteps;
/**
 * Map a wizard step index to the section index it represents (or -1 for the
 * synthetic review step).
 */
function sectionIndexForStep(definition, stepIndex) {
    let count = 0;
    for (let i = 0; i < definition.sections.length; i++) {
        if (definition.sections[i].id === 'extras')
            continue;
        if (count === stepIndex)
            return i;
        count++;
    }
    return -1;
}
exports.sectionIndexForStep = sectionIndexForStep;
/** Find the section in the definition that holds "extras" content (remarks, coupon, …). */
function findExtrasSection(definition) {
    return definition.sections.find((s) => s.id === 'extras');
}
exports.findExtrasSection = findExtrasSection;
